<template>
  <div class="btn-group">
    <div v-for="(btn,i) in group" :key="`bg_${i}`" :class="btn.selected&&'selected'" class="item" @click="$emit('change',i,name)">
      <span v-text="btn.name"/>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ButtonGroup',
  props: {
    name: {
      type: String,
      default: ''
    },
    group: {
      type: Array,
      required: true
    }
  }
}
</script>

<style scoped lang="less">
.btn-group {
  display: inline-block;
  .item.selected {
    border-color: #00D868;
    color: #ffffff;
    background-color: #00D868;
    position: relative;
  }
  .item {
    border: 1px solid #D9D9D9;
    padding: 6px 16px;
    font-size: 14px;
    font-weight: 400;
    cursor: pointer;
    display: inline-block;
    color: rgba(99, 99, 99, 1);
  }
  .item:first-child {
    border-radius: 2px 0px 0px 2px;
    margin-left: 0px;
  }
  .item:last-child {
    border-radius: 0px 2px 4px 2px;
    margin-left: -1px;
  }
}
</style>
